/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

$(document).ready(function () {
  $(".template-product .selector-wrapper .radio__buttons .radio__button").on(
    "click",
    function () {
      var selected = $(this).attr("data-btn");
      // alert(selected);
      $(".faq_inner .accordion-1 .accordion__body").each(function () {
        var selectedtab = $(this).attr("data-tab");
        // alert(selectedtab);
        if (selected == selectedtab) {
          $(this).show();
          $(this).removeClass("is-hidden");
        } else {
          $(this).hide();
          $(this).addClass("is-hidden");
          $(
            ".option-frequence .radio__buttons .radio__button:first-child label"
          ).trigger("click");
        }
      });
    }
  );

  $(
    ".template-product .faq_inner .accordion .meta-info.faq-item .info-title"
  ).on("click", function () {
    $(this).parent(".meta-info.faq-item .meta-block").toggleClass("is-active");
  });

  $(
    ".template-article .article__content.rte .article__recipe-ingredients ul li"
  ).on("click", function () {
    $(this).toggleClass("is-active");
  });

  $(
    ".header__drawer .drawer__content .menu__item.resources .mega-menu__linklist p.menu__heading"
  ).on("click", function () {
    $(this).parent(".mega-menu__linklist").toggleClass("is-active");
  });

  $(".option-frequence .radio__buttons .radio__button label").each(function () {
    $(this).on("click", function () {
      $(".option-frequence .radio__buttons .radio__button input").prop(
        "checked",
        false
      );
      var new_selling_palin = $(this)
        .parents(".radio__button")
        .find("input")
        .val();

      $(
        ".pro_bundle_and_save.pro_subscription_area #product-selected-selling-plan"
      ).val(new_selling_palin);
      $(this).parents(".radio__button").find("input").prop("checked", true);
    });
  });

  $(".template-product .standard__ctas").click(function () {
    $("html, body").animate({ scrollTop: 0 });
    return false;
  });

  // First product from bundle
  let setinterval;

  setinterval = setInterval(() => {
    var firstRebuyBlock = $(".rebuy-product-block:first");
    if (firstRebuyBlock.is(":visible")) {
      firstRebuyBlock.hide();
      firstRebuyBlock.find(".is-select").removeClass("is-select");
      firstRebuyBlock.find('input[type="checkbox"]').click();
      console.log("document Unload");
      clearInterval(setinterval); // Clear the interval after the event occurs
    }
  }, 2000);
});
